import apiClient from '@/services/api-client';

export default {
	getStaticAsset() {
		return apiClient().post('/StaticAsset/GetStaticAsset', {});
	},
};
